export function validateRequired(field, values, errors) {
  if (!values[field.name] && !field.optional) {
    errors[field.name] = `Pole ${field.label} jest wymagane`;
  }
}

const phoneRegexp = /([0-9]{9})|([0-9]{3} [0-9]{3} [0-9]{3})|([0-9]{3}-[0-9]{3}-[0-9]{3})|(\+\d{11})|(\+\d{2}-\d{3}-\d{3}-\d{3})|(\+\d{2} \d{3} \d{3} \d{3})/;

export function isValidPhone(phone) {
  return phoneRegexp.test(phone);
}

const emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function isValidEmail(email) {
  return emailRegexp.test(email);
}
